<template lang="html">
  <v-card>
    <v-toolbar color="grey" dark>
      <v-toolbar-side-icon></v-toolbar-side-icon>
      <v-toolbar-title>Add New Role</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn @click.native.stop="saveRole()" round color="primary" dark>Save Role</v-btn>
      <v-btn @click.native="activeDialog()" round color="red" dark>Close</v-btn>
    </v-toolbar>
      <v-list three-line subheader>
        <v-card class="pa-4" flat>
          <v-text-field
            label="Role Title"
            v-model="roleTitle"
            required
          ></v-text-field>
          <span v-if="!valid" style="color: red; font-size: 12px;">Title field is required</span>
        </v-card>
        <v-subheader>Events</v-subheader>
        <v-list-tile>
          <v-list-tile-action>
            <v-checkbox
              v-model="newPriviledge.events.create_event"
              readonly
            ></v-checkbox>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Create Events</v-list-tile-title>
            <v-list-tile-sub-title>Allow users to be able to create events</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <!-- <v-subheader>Groups</v-subheader>
        <v-list-tile>
          <v-list-tile-action>
            <v-checkbox
              v-model="newPriviledge.groups.create_group"
              readonly
            ></v-checkbox>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Create Group</v-list-tile-title>
            <v-list-tile-sub-title>Allow users to be able to create groups</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-action>
            <v-checkbox
              v-model="newPriviledge.groups.post_to_group"
              readonly
            ></v-checkbox>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Post to Groups</v-list-tile-title>
            <v-list-tile-sub-title>Allow users to be able to post to groups</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-action>
            <v-checkbox
              v-model="newPriviledge.groups.create_event"
              readonly
            ></v-checkbox>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Create Group Events</v-list-tile-title>
            <v-list-tile-sub-title>Allow users to be able to create group events</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider> -->
        <v-subheader>Activity Stream</v-subheader>
        <v-list-tile>
          <v-list-tile-action>
            <v-checkbox
              v-model="newPriviledge.activity_stream.post_to_activity"
              readonly
            ></v-checkbox>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Post to Activity Stream</v-list-tile-title>
            <v-list-tile-sub-title>Allow users to be able to create post in activity stream</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
         <v-subheader>Economic Impact</v-subheader>
              <v-list-tile>
                <v-list-tile-action>
                  <v-checkbox
                    v-model="newPriviledge.economic_impact.all_access"
                    @click.native.stop="giveAllAccessToEconomicImpact()"
                    readonly
                  ></v-checkbox>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>All Access</v-list-tile-title>
                  <v-list-tile-sub-title>Give full access to the economic impact module</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile
                v-for="(analysis, index) in analysisList"
                :key="index">
                <v-list-tile-action>
                  <v-checkbox
                    v-model="newPriviledge.economic_impact[analysis.id]"
                    @click.native.stop="unCheckEconomicImpactAllAccess()"
                    readonly
                  ></v-checkbox>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{ analysis.text }}</v-list-tile-title>
                  <v-list-tile-sub-title>Give access to the <span style="text-transform: lowercase">{{ analysis.text }}</span></v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider></v-divider>
        <v-subheader>Chat</v-subheader>
        <v-list-tile href="javascript:;">
          <v-list-tile-action>
            <v-checkbox
              v-model="newPriviledge.chat.group_chat"
              readonly
            ></v-checkbox>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Group Chats</v-list-tile-title>
            <v-list-tile-sub-title>Allow users to be able to send messages in groups</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile href="javascript:;">
          <v-list-tile-action>
            <v-checkbox
            v-model="newPriviledge.chat.private_chat"></v-checkbox>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Private Chats</v-list-tile-title>
            <v-list-tile-sub-title>Allow users to be able to send private messages across users</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile href="javascript:;">
          <v-list-tile-action>
            <v-checkbox
            v-model="newPriviledge.chat.video_chat"></v-checkbox>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Video Chats</v-list-tile-title>
            <v-list-tile-sub-title>Enables users access to video chats</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile href="javascript:;">
          <v-list-tile-action>
            <v-checkbox v-model="newPriviledge.chat.voice_chat"></v-checkbox>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Voice Chats</v-list-tile-title>
            <v-list-tile-sub-title>Enables users access to voice chats</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-list three-line subheader>
        <v-subheader>Email Updates</v-subheader>
        <v-list-tile href="javascript:;">
          <v-list-tile-action>
            <v-checkbox
              v-model="newPriviledge.email_updates.access"
              readonly
            ></v-checkbox>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Enable Access</v-list-tile-title>
            <v-list-tile-sub-title>Allows users to receive email updates</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile href="javascript:;">
          <v-list-tile-content>
            <v-list-tile-title>Set limit for Email Update</v-list-tile-title>
            <v-list-tile-sub-title>Limit the number of email updates</v-list-tile-sub-title>
          </v-list-tile-content>
          <v-radio-group v-model="newPriviledge.email_updates.limit" row>
            <v-radio label="5" :value="5" ></v-radio>
            <v-radio label="10" :value="10"></v-radio>
          </v-radio-group>
        </v-list-tile>
      </v-list>
    <v-card>
      <v-toolbar flat color="white" dark>
        <v-toolbar-side-icon></v-toolbar-side-icon>
        <v-spacer></v-spacer>
        <span v-if="!valid" style="color: red; font-size: 12px;">Title field is required</span>
        <v-btn @click.native.stop="saveRole()" round color="primary" dark>Save Role</v-btn>
        <v-btn @click.native.stop="activeDialog()" round color="red" dark>Close</v-btn>
      </v-toolbar>
    </v-card>
  </v-card>
</template>

<script>
export default {
  props: ['activeDialog', 'length'],
  methods: {
    saveRole () {
      if (this.roleTitle) {
        const payload = {
          level: this.roleLevel,
          priviledges: {
            ...this.newPriviledge,
            title: this.roleTitle
          }
        }
        this.$store.dispatch('addPriviledge', payload)
        this.activeDialog()
        this.roleTitle = ''
        this.newPriviledge = {
          events: {
            create_event: false
          },
          email_updates: {
            access: false,
            limit: 0
          },
          economic_impact: {},
          activity_stream: {
            post_to_activity: false
          },
          chat: {
            voice_chat: false,
            video_chat: false,
            private_chat: false,
            group_chat: false
          },
          groups: {
            create_event: false,
            create_group: false,
            post_to_group: false
          }
        }
      } else {
        this.valid = false
      }
    },
    giveAllAccessToEconomicImpact () {
      for (var analysis of this.analysisList) {
        this.newPriviledge.economic_impact[analysis.id] = this.newPriviledge.economic_impact.all_access
      }
      this.newPriviledge.economic_impact.has_access = this.newPriviledge.economic_impact.all_access
    },
    unCheckEconomicImpactAllAccess (val) {
      let hasTrueValues = false
      this.newPriviledge.economic_impact.all_access = false
      for (var value in this.newPriviledge.economic_impact) {
        if (this.newPriviledge.economic_impact[value] && value !== 'has_access') {
          hasTrueValues = true
        }
      }
      this.newPriviledge.economic_impact.has_access = hasTrueValues
    }
  },
  data () {
    return {
      limits: [
        {
          text: '5',
          value: 5
        },
        {
          text: '10',
          value: 10
        }
      ],
      roleTitle: '',
      valid: true,
      newPriviledge: {
        events: {
          create_event: false
        },
        email_updates: {
          access: false,
          limit: 0
        },
        activity_stream: {
          post_to_activity: false
        },
        economic_impact: {},
        chat: {
          voice_chat: false,
          video_chat: false,
          private_chat: false,
          group_chat: false
        },
        groups: {
          create_event: false,
          create_group: false,
          post_to_group: false
        }
      },
      analysisList: [
        {
          text: 'Spending Analysis by Geography',
          id: 'spending-analysis-by-geography',
          html: `<div class='tableauPlaceholder' style='width: 1000px; height: 3050px;'><object class='tableauViz' width='1000' height='3050' style='display:none;'><param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='&#47;t&#47;tsvanalytics' /><param name='name' value='GDEcD_EconomicAnalysis_12172018&#47;GeorgiaDoD_Geography' /><param name='tabs' value='yes' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /><param name='filter' value='iframeSizedToWindow=true' /></object></div>`,
          embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_12172018/GeorgiaDoD_Geography?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
        },
        {
          text: 'DoD Contract Trends',
          id: 'dod-contract-trends',
          html: `<div class='tableauPlaceholder' style='width: 1000px; height: 1550px;'><object class='tableauViz' width='1000' height='1550' style='display:none;'><param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='&#47;t&#47;tsvanalytics' /><param name='name' value='GDEcD_EconomicAnalysis_12172018&#47;DoDContractTrends' /><param name='tabs' value='yes' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /><param name='filter' value='iframeSizedToWindow=true' /></object></div>`,
          embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_12172018/DoDContractTrends?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
        },
        {
          text: 'Military Installations',
          id: 'military-installations',
          html: `<div class='tableauPlaceholder' style='width: 1000px; height: 827px;'><object class='tableauViz' width='1000' height='827' style='display:none;'><param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='&#47;t&#47;tsvanalytics' /><param name='name' value='GDEcD_EconomicAnalysis_MilitaryInstallations_12172018&#47;MilitaryInstallations' /><param name='tabs' value='no' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /><param name='filter' value='iframeSizedToWindow=true' /></object></div>`,
          embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_MilitaryInstallations_12172018/MilitaryInstallations?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
        },
        {
          text: 'Prime-Sub Spending Flow',
          id: 'prime-sub-spending-flow',
          html: `<div class='tableauPlaceholder' style='width: 1000px; height: 4050px;'><object class='tableauViz' width='1000' height='4050' style='display:none;'><param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='&#47;t&#47;tsvanalytics' /><param name='name' value='GDEcD_EconomicAnalysis_12172018&#47;DoDPrime-SubSpendingFlow' /><param name='tabs' value='yes' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /><param name='filter' value='iframeSizedToWindow=true' /></object></div>`,
          embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_12172018/DoDPrime-SubSpendingFlow?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
        },
        {
          text: 'DoD Agency Spending Flow',
          id: 'dod-agency-spending-flow',
          html: `<div class='tableauPlaceholder' style='width: 1000px; height: 4050px;'><object class='tableauViz' width='1000' height='4050' style='display:none;'><param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='&#47;t&#47;tsvanalytics' /><param name='name' value='GDEcD_EconomicAnalysis_12172018&#47;DoDAgencySpendingFlow' /><param name='tabs' value='yes' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /><param name='filter' value='iframeSizedToWindow=true' /></object></div>`,
          embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_12172018/DoDAgencySpendingFlow?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
        },
        {
          text: 'Future Needs of the DoD',
          id: 'future-needs-of-the-dod',
          html: `<div class='tableauPlaceholder' style='width: 1000px; height: 850px;'><object class='tableauViz' width='1000' height='850' style='display:none;'><param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='&#47;t&#47;tsvanalytics' /><param name='name' value='GDEcD_EconomicAnalysis_Part3_12172018&#47;FutureNeedsoftheDoD' /><param name='tabs' value='yes' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /><param name='filter' value='iframeSizedToWindow=true' /></object></div>`,
          embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_Part3_12172018/FutureNeedsoftheDoD?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
        },
        {
          text: 'DoD Contract View',
          id: 'dod-contract-view',
          html: `<div class='tableauPlaceholder' style='width: 1000px; height: 1550px;'><object class='tableauViz' width='1000' height='1550' style='display:none;'><param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='&#47;t&#47;tsvanalytics' /><param name='name' value='GDEcD_EconomicAnalysis_12172018&#47;DoDContractView' /><param name='tabs' value='yes' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /><param name='filter' value='iframeSizedToWindow=true' /></object></div>`,
          embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_12172018/DoDContractView?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
        },
        {
          text: 'DoD Contractor View',
          id: 'dod-contractor-view',
          html: `<div class='tableauPlaceholder' style='width: 1000px; height: 1550px;'><object class='tableauViz' width='1000' height='1550' style='display:none;'><param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='&#47;t&#47;tsvanalytics' /><param name='name' value='GDEcD_EconomicAnalysis_12172018&#47;DoDContractorView' /><param name='tabs' value='yes' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /><param name='filter' value='iframeSizedToWindow=true' /></object></div>`,
          embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_12172018/DoDContractorView?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
        },
        {
          text: 'GDX Directory vs. Georgia DoD Contract Winners',
          id: 'gdx-directory-vs-georgia-dod-contract-winners',
          html: `<div class='tableauPlaceholder' style='width: 1000px; height: 850px;'><object class='tableauViz' width='1000' height='850' style='display:none;'><param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='&#47;t&#47;tsvanalytics' /><param name='name' value='GDEcD_EconomicAnalysis_Part3_12172018&#47;GDXDirectoryvs_GeorgiaDoDContractWinners' /><param name='tabs' value='yes' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /><param name='filter' value='iframeSizedToWindow=true' /></object></div>`,
          embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_Part3_12172018/GDXDirectoryvs_GeorgiaDoDContractWinners?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
        },
        {
          text: 'Georgia Contractor Analysis',
          id: 'georgia-contractor-analysis',
          html: `<div class='tableauPlaceholder' style='width: 1000px; height: 3050px;'><object class='tableauViz' width='1000' height='3050' style='display:none;'><param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='&#47;t&#47;tsvanalytics' /><param name='name' value='GDEcD_EconomicAnalysis_12172018&#47;GeorgiaDoD_Contractor' /><param name='tabs' value='yes' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /><param name='filter' value='iframeSizedToWindow=true' /></object></div>`,
          embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_12172018/GeorgiaDoD_Contractor?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
        }
      ]
    }
  },
  computed: {
    roleLevel () {
      return this.length
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// NewRole.vue?7d2c6d1d